import React, {PureComponent} from "react"
import qs from "qs"

import Button from "@irati/ui/src/Button"
import {Body, H2, Label} from "@irati/ui/src/Typography"
import Flex from "@irati/ui/src/Flex"
import theme from "@irati/ui/src/global/theme"
import workosService from "@irati/workos/services/workos"
import FormattedMessage from "@irati/utils/lang"
import Loading from "@irati/ui/src/Loading"
import {PerkboxLogo} from "@irati/ui/src/Logos"
import withBranding, {WithBranding} from "@irati/brand/withBranding"
import {getErrorValues} from "@irati/utils/lang/formatError"
import WorkOSCodes from "@irati/workos/errorCodes/WorkOS"

import {StyledLogo} from "../../components/Header/shared/styled"
import {StyledImg, StyledWarningImg} from "./styled"

interface Props extends WithBranding{}

interface State {
  load: Promise<any> | null,
  ssoUrl: string,
  dsyncUrl: string,
  isLinkExpired: boolean
}

class WorkOSIntegrationsLink extends PureComponent<Props, State> {
  state: State = {
    load: null,
    ssoUrl: "",
    dsyncUrl: "",
    isLinkExpired: false
  }

  componentDidMount() {
    const query = qs.parse(location.href.split("?")[1])
    const load = workosService.generateSetupLinksFromCode(query.code)
      .then((portalLinks) => {
        this.setState({ssoUrl: portalLinks.ssoUrl, dsyncUrl: portalLinks.directorySyncUrl})
      }).catch((err: PBError) => {
        const errorCode = getErrorValues(err)?.errorCode
        if (errorCode?.includes(WorkOSCodes.PBWORKOSConnectionsAlreadyExist)) {
          this.setState({ssoUrl: "", dsyncUrl: ""})
        }
        else if (errorCode?.includes(WorkOSCodes.PBWORKOSExpiredCode)) {
          this.setState({isLinkExpired: true})
        }
      })
    this.setState({load})
  }

  handleLink = (_, ssoLink?: boolean) => {
    window.location.href = ssoLink ? this.state.ssoUrl : this.state.dsyncUrl
  }

  render() {
    const {ssoUrl, dsyncUrl, isLinkExpired, load} = this.state
    const {businessLogoUrl} = this.props.branding

    return (
      <Loading load={load}>
        <Flex height="50px" justifyContent="space-between" margin={[2, 5]}>
          <StyledLogo src={businessLogoUrl} />
          <div>
            <Label weight="bold" small marginBottom marginRight={1}>
              <FormattedMessage id="platform.ui.poweredBy" />
            </Label>
            <PerkboxLogo size={28} />
          </div>
        </Flex>
        {isLinkExpired
          ? <Flex marginTop={5} alignContent="center" justifyContent="center" alignItems="center" gap={theme.spacing.two} padding={[5, 10]}>
            <Flex direction="column">
              <H2 marginBottom={1}>
                <FormattedMessage id="platform.workOSIntegrationsLink.linkExpiredTitle" />
              </H2>
              <Body marginBottom={2}>
                <FormattedMessage id="platform.workOSIntegrationsLink.linkExpiredDesc" />
              </Body>
            </Flex>
            <StyledWarningImg />
          </Flex>
          : <Flex marginTop={5} alignContent="center" justifyContent="center" alignItems="center" gap={theme.spacing.two} padding={[5, 10]}>
            <Flex direction="column">
              <H2 marginBottom={1}>
                <FormattedMessage id="platform.workOSIntegrationsLink.title" />
              </H2>
              <Body marginBottom={2}>
                <FormattedMessage
                  id="platform.workOSIntegrationsLink.desc"
                  values={{expiryHours: <Label large weight="bold">
                    <FormattedMessage
                      id="platform.workOSIntegrationsLink.expiryHours" />
                  </Label>
                  }} />
              </Body>
              <div>
                <Button marginRight={2} primary onClick={this.handleLink} disabled={!dsyncUrl}>
                  <FormattedMessage id="platform.workOSIntegrationsLink.dsync" />
                </Button>
                <Button marginTop={1} primary onClick={(e) => this.handleLink(e, true)} disabled={!ssoUrl}>
                  <FormattedMessage id="platform.workOSIntegrationsLink.sso" />
                </Button>
              </div>
            </Flex>
            <StyledImg />
          </Flex>}
      </Loading>
    )
  }
}

export default withBranding(WorkOSIntegrationsLink)
